var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDragAndDrop = function SvgDragAndDrop(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 8,
    "data-width-24": 12,
    viewBox: "0 0 7.4 12",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.667 1.333a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0m-1.334 6a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.667m0 4.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M7.333 1.333a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0m-1.334 6a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.667m0 4.668a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDragAndDrop);
export default ForwardRef;